import { createContext, useContext } from 'react';

import { GetUploadedFilesWithHeaders } from 'query/__generated__/getUploadedFilesWithHeaders';
type GetUploadedFilesWithHeaders_user_company_loan_tapes = NonNullable<
  NonNullable<
    NonNullable<NonNullable<GetUploadedFilesWithHeaders>['user']>['company']
  >['loan_tapes']
>[number];
type UploadedFile = NonNullable<
  NonNullable<
    NonNullable<NonNullable<GetUploadedFilesWithHeaders>['user']>['company']
  >['loan_tapes']
>[number];
const TapeUploadContext = createContext<TapeUploadContextProps | undefined>(undefined);

export interface TapeUploadContextProps {
  uploadedTapes: GetUploadedFilesWithHeaders_user_company_loan_tapes[] | undefined;

  // TODO this should become a search param so that users can share the selected file
  selectedFileId: string | undefined;
  setSelectedFileId: (id: string | undefined) => void;

  selectedFile: UploadedFile | undefined;
}

export const useTapeUploadContext = () => {
  const context = useContext(TapeUploadContext);
  if (!context) {
    throw new Error('This component must be used within a TapeUploadContext.Provider');
  }
  return context;
};

export default TapeUploadContext;
